import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { ExternalSourceUrlActionKey as ActionKey } from "./ActionKeys";

export interface SetExternalSourceUrlAction
  extends AppAction<
    ActionKey.SET_EXTERNAL_SOURCE_URL,
    {
      externalSourceUrl: string | null;
    }
  > {}

export type ExternalSourceUrlAction = SetExternalSourceUrlAction;

export const setExternalSourceUrl = (
  externalSourceUrl: string | null
): SetExternalSourceUrlAction =>
  getStore().dispatch({
    type: ActionKey.SET_EXTERNAL_SOURCE_URL,
    payload: { externalSourceUrl },
  });
